enum AccountDetailsLoanType {
  BOLIGLÅN = 'BOLIGLÅN',
  FASTRENTELÅN = 'FASTRENTELÅN',
  RAMMELÅN = 'RAMMELÅN',
  MELLOMFINANSIERING = 'MELLOMFINANSIERING',
}

export default AccountDetailsLoanType;
